import styled from "styled-components";


interface LogoProps {
  dashboardscreen: string;
  darktext?: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  z-index: 600;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 18px 32px;

  @media (max-width: 768px) {
    padding: 14px 20px;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  position: relative;
  z-index: 1;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoStyle = styled.img<LogoProps>`
  height: 36px;
  width: auto;
  object-fit: contain;
  cursor: pointer;
  filter: ${({ darktext }) => darktext === 'true' ? 'none' : 'brightness(0) invert(1)'};

  @media (max-width: 768px) {
    height: 28px;
  }
`;

export const NavLinksContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const NavbarTitle = styled.span<{ active?: boolean; darktext?: string }>`
  font-size: 15px;
  color: ${({ darktext }) => darktext === 'true' ? '#000000' : '#ffffff'};
  font-family: 'Aileron', sans-serif;
  font-weight: ${({ active }) => (active ? 700 : 400)};
`;

export const TitleTab = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const LoginButton = styled.div<{ darktext?: string }>`
  padding: 9px 22px;
  background-color: transparent;
  border: 1.5px solid ${({ darktext }) => darktext === 'true' ? '#000000' : '#ffffff'};
  border-radius: 24px;
  cursor: pointer;
  font-size: 14px;
  color: ${({ darktext }) => darktext === 'true' ? '#000000' : '#ffffff'};
  font-family: 'Aileron', sans-serif;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ darktext }) => darktext === 'true' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.15)'};
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 7px 16px;
  }
`;

export const SignUpButton = styled.div`
  padding: 9px 22px;
  background-color: #000000;
  border: 1.5px solid #000000;
  border-radius: 24px;
  cursor: pointer;
  font-size: 14px;
  color: #ffffff;
  font-family: 'Aileron', sans-serif;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:hover {
    background-color: #222222;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 7px 16px;
  }
`;

export const BasketStyle = styled.img<{ basketproduct: string; userdashboard: string }>`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const MobileMenuOverlay = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 16px;
  width: 260px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  padding: 4px 0 16px 0;
  z-index: 599;
`;

export const MobileMenuItem = styled.div`
  padding: 15px 24px;
  font-family: 'Aileron', sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: #111111;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const MobileMenuDivider = styled.div`
  height: 1px;
  background-color: #eeeeee;
  margin: 8px 0;
`;

export const MobileMenuAction = styled.div<{ variant: 'solid' | 'outline' }>`
  margin: 6px 20px 0 20px;
  padding: 11px 0;
  border-radius: 24px;
  text-align: center;
  font-family: 'Aileron', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  ${({ variant }) => variant === 'solid' ? `
    background-color: #000000;
    color: #ffffff;
    &:hover { background-color: #222222; }
  ` : `
    background: none;
    border: 1.5px solid #dddddd;
    color: #333333;
    &:hover { background-color: #f4f4f4; border-color: #bbbbbb; }
  `}
`;
